'use strict';

// The negative-finding marker provider (plan §3.4): "we searched and no
// defensible source exists" recorded as a mapped_from entry
export const NOT_COMPLETABLE_PROVIDER = 'not-completable';
export const NOT_PRESENT_PROVIDER = 'not-present';
export const MONASH_PROVIDER = 'monash';
// Values we reviewed and calculated ourselves (e.g. the Fruits & Vegetables
// transformation of the ADA's recommendations) — the note carries the method
export const DIETITIAN_PROVIDER = 'dietitian';
export const FDC_PROVIDER = 'FoodsData Central';

export default [
    {
        provider: 'url',
        name: 'Web Source',
        logo: '',
    },
    {
        provider: FDC_PROVIDER,
        name: 'FoodsData Central',
        logo: '',
        url_template: 'https://fdc.nal.usda.gov/food-details/{id}/nutrients',
    },
    {
        provider: 'Restaurant Menu',
        name: 'Restaurant Menu',
        logo: '',
    },
    {
        provider: 'walmart',
        name: 'Walmart',
        logo: 'https://static.chewba.info/images/walmart-logo.svg',
        url_template: 'https://www.walmart.com/ip/{id}',
    },
    {
        provider: 'amazon',
        name: 'Amazon Fresh',
        logo: 'https://static.chewba.info/images/amazon-fresh-logo-2.png',
    },
    {
        provider: 'kroger',
        name: 'Kroger',
        logo: 'https://static.chewba.info/images/kroger-logo.svg',
    },
    {
        provider: 'safeway',
        name: 'Safeway',
        logo: 'https://static.chewba.info/images/safeway-logo.svg',
    },
    {
        provider: 'target',
        name: 'Target',
        logo: 'https://static.chewba.info/images/target-logo.svg',
    },
    {
        provider: 'sunbasket',
        name: 'Sunbasket',
        logo: 'https://static.chewba.info/images/sunbasket-logo.svg',
    },
    {
        provider: 'costco',
        name: 'Costco',
        logo: '',
    },
    {
        provider: 'wholefoods',
        name: 'Whole Foods',
        logo: 'https://static.chewba.info/images/wholefoods-logo.svg',
    },
    {
        provider: 'Save-On-Foods',
        name: 'Save-On-Foods',
        logo: '',
    },
    {
        provider: 'image',
        name: 'Photo Evidence',
        logo: '',
    },
    {
        provider: 'isbn',
        name: 'Book (ISBN)',
        logo: '',
        url_template: 'https://openlibrary.org/isbn/{id}',
    },
    {
        provider: MONASH_PROVIDER,
        name: 'Monash FODMAP',
        logo: '',
    },
    {
        provider: DIETITIAN_PROVIDER,
        name: 'Dietitian Reviewed & Calculated',
        logo: '',
    },
    {
        provider: NOT_COMPLETABLE_PROVIDER,
        name: 'Not Completable',
        logo: '',
    },
    {
        provider: NOT_PRESENT_PROVIDER,
        name: 'Not Present In Food',
        logo: '',
    },
];
